module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('m-head', {
    attrs: {
      "title": _vm.shopname
    },
    on: {
      "search": function($event) {
        _vm.searchBox = true
      }
    }
  }), _vm._v(" "), (_vm.scrollH) ? _c('scroller', {
    ref: "scrollerEvent",
    staticClass: "r flex-1",
    attrs: {
      "scroll-bottom-offset": 50,
      "height": _vm.scrollH,
      "lock-x": ""
    },
    on: {
      "on-scroll-bottom": _vm.onScrollBtm
    }
  }, [_c('div', {
    staticClass: "box2"
  }, [(_vm.banners.length > 0) ? _c('m-swiper', {
    attrs: {
      "banner": _vm.banners
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "lables flex vux-1px-b"
  }, _vm._l((_vm.navitems), function(row, index) {
    return _c('div', {
      key: index
    }, [_c('router-link', {
      attrs: {
        "to": row.url
      }
    }, [_c('img', {
      attrs: {
        "src": _vm.UPLOAD_DOMAIN + row.image + '?x-oss-process=image/resize,w_100',
        "default-src": "static/placeholder.png",
        "container": "#vux_view_box_body"
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(row.title))])])], 1)
  })), _vm._v(" "), _c('div', {
    staticClass: "recommend list ",
    staticStyle: {
      "background": "#fff"
    }
  }, [_c('div', {
    staticClass: "title vux-1px-b recommend-title border-0"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("推荐商品")])]), _vm._v(" "), _vm._l((_vm.productList), function(product, index) {
    return _c('div', {
      key: product._id,
      staticClass: "box vux-1px-b",
      on: {
        "click": function($event) {
          _vm.toPage(product._id)
        }
      }
    }, [_c('div', {
      staticClass: "img",
      class: 'img-' + index
    }, [_c('img', {
      attrs: {
        "src": _vm.UPLOAD_DOMAIN + product.thumbnail + '?x-oss-process=image/resize,w_120',
        "default-src": "static/placeholder.png",
        "container": "#vux_view_box_body"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "wz"
    }, [_c('div', {}, [_vm._v("\n                            " + _vm._s(product.title) + "\n                            "), (product.specLabel) ? _c('span', [_vm._v("(" + _vm._s(product.specLabel) + ")")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "ellipsis"
    }, [_vm._v("\n                            " + _vm._s(product.subTitle) + "\n                            "), (product.areaLimit) ? _c('span', [_vm._v("(限售湖北)")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "money"
    }, [_vm._v("￥" + _vm._s(_vm._f("fen2yuan")(product.price)))]), _vm._v(" "), _c('div', {
      staticClass: "add-cart",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.addCart(product._id, product.category, 'img-' + index, _vm.UPLOAD_DOMAIN + product.thumbnail + '?x-oss-process=image/resize,w_120')
        }
      }
    }, [_c('i', {
      staticClass: "icon-jia iconfont text-center"
    })])])])
  }), _vm._v(" "), (_vm.productList.length > 0) ? _c('load-more', {
    attrs: {
      "tip": _vm.loadText,
      "background-color": "white",
      "show-loading": _vm.isMoreList
    }
  }) : _vm._e()], 2)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.searchBox),
      expression: "searchBox"
    }],
    staticClass: "searh-box"
  }, [_c('m-search', {
    attrs: {
      "searchBox": _vm.searchBox
    },
    on: {
      "searchHide": function($event) {
        _vm.searchBox = false
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5f341d3c"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Home.vue
// module id = 578
// module chunks = 0